<script setup lang="ts">
import type {Goal} from '@/ts/types/dto/interventions-dto';

defineProps<{
  goal: Goal;
  order: number;
}>();
</script>
<template>
  <div class="goal">
    <div class="order">
      {{ order }}
    </div>
    <div class="name">
      {{ goal.name }}
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-safe-html="goal.descriptionHTML" class="body"/>
  </div>
</template>
<style scoped lang="scss">
.goal {
  width: 240px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  padding: var(--Spacing-spacing-8) var(--Spacing-spacing-7) var(--Spacing-spacing-9) var(--Spacing-spacing-6);
  @include q-card-20;
  @include screen-md {
    min-height: 400px;
  }
  @include screen-lg {
    width: 320px;
  }
}

.order {
  @include font-metric-lg;
}

.name {
  @include font-body-bold;
  margin-bottom: var(--Spacing-spacing-2);
}

.body {
  @include font-body-sm;
  flex: 1; /* Make the body take up the remaining space */
}
</style>
